import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { YieldMonthlyResponse } from 'src/app/models/yield-response.model'

@Injectable({
  providedIn: 'root',
})
export class YieldsService {
  public static readonly yieldsEndpoint = '/yields'

  constructor(private readonly http: HttpClient) {}

  getYields(fundId: string): Observable<YieldMonthlyResponse> {
    return this.http.get<YieldMonthlyResponse>(
      `vmf/api/${fundId}`.concat(YieldsService.yieldsEndpoint),
    )
  }
}
